<!-- ============================================ -->
<!-- ZONE 1 — Active Templates Skeleton           -->
<!-- ============================================ -->
<div class="skel-zone">
  <!-- Zone header -->
  <div class="skel-zone-header">
    <app-skeleton-rect width="24px" height="24px" borderRadius="50%"></app-skeleton-rect>
    <app-skeleton-rect width="220px" height="22px"></app-skeleton-rect>
  </div>

  <!-- Active cards (horizontal 50/50 layout) -->
  <div *ngFor="let card of activeCards; let i = index"
    class="skel-active-card"
    [class.skel-active-card--primary]="i === 0"
    [class.skel-active-card--draft]="i === 1">

    <!-- Draft label banner for 2nd card -->
    <div class="skel-draft-banner" *ngIf="i === 1">
      <app-skeleton-rect width="180px" height="14px" borderRadius="4px"></app-skeleton-rect>
    </div>

    <div class="skel-active-card__inner">
      <!-- Thumbnail side (50%) -->
      <div class="skel-active-card__thumbnail">
        <app-skeleton-rect width="100%" height="100%" borderRadius="0"></app-skeleton-rect>
      </div>

      <!-- Info side (50%) -->
      <div class="skel-active-card__info">
        <!-- Badges row -->
        <div class="skel-badges">
          <app-skeleton-rect width="110px" height="28px" borderRadius="1rem"></app-skeleton-rect>
          <app-skeleton-rect width="80px" height="28px" borderRadius="1rem"></app-skeleton-rect>
        </div>

        <!-- Title -->
        <app-skeleton-rect width="65%" height="26px" borderRadius="6px"></app-skeleton-rect>

        <!-- Description lines -->
        <div class="skel-desc-lines">
          <app-skeleton-rect width="100%" height="14px"></app-skeleton-rect>
          <app-skeleton-rect width="85%" height="14px"></app-skeleton-rect>
        </div>

        <!-- Tag chips -->
        <div class="skel-tag-chips">
          <ng-container *ngFor="let chip of tagChips; let j = index">
            <app-skeleton-rect
              [width]="j % 2 === 0 ? '90px' : '70px'"
              height="26px"
              borderRadius="2rem">
            </app-skeleton-rect>
          </ng-container>
        </div>

        <!-- Thumbnail strip -->
        <div class="skel-thumb-strip">
          <ng-container *ngFor="let t of thumbStrip">
            <app-skeleton-rect width="56px" height="40px" borderRadius="6px"
              [style.min-width]="'56px'" [style.min-height]="'40px'">
            </app-skeleton-rect>
          </ng-container>
        </div>

        <!-- Action buttons -->
        <div class="skel-actions">
          <app-skeleton-rect width="160px" height="42px" borderRadius="8px"></app-skeleton-rect>
          <app-skeleton-rect width="120px" height="42px" borderRadius="8px"></app-skeleton-rect>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============================================ -->
<!-- ZONE 2 — Catalog Skeleton                    -->
<!-- ============================================ -->
<div class="skel-zone">
  <!-- Zone header with tabs -->
  <div class="skel-zone-header skel-zone-header--catalog">
    <div>
      <div class="skel-zone-header__title-row">
        <app-skeleton-rect width="24px" height="24px" borderRadius="50%"></app-skeleton-rect>
        <app-skeleton-rect width="200px" height="22px"></app-skeleton-rect>
      </div>
      <app-skeleton-rect width="280px" height="14px" class="skel-subtitle"></app-skeleton-rect>
    </div>
    <div class="skel-tabs">
      <app-skeleton-rect width="60px" height="32px" borderRadius="6px"></app-skeleton-rect>
      <app-skeleton-rect width="100px" height="32px" borderRadius="6px"></app-skeleton-rect>
      <app-skeleton-rect width="70px" height="32px" borderRadius="6px"></app-skeleton-rect>
    </div>
  </div>

  <!-- Featured card (horizontal 50/50) -->
  <div class="skel-featured-card">
    <div class="skel-featured-card__inner">
      <!-- Carousel side (50%) -->
      <div class="skel-featured-card__carousel">
        <app-skeleton-rect width="100%" height="100%" borderRadius="0"></app-skeleton-rect>
      </div>

      <!-- Info side (50%) -->
      <div class="skel-featured-card__info">
        <!-- Pro badge -->
        <app-skeleton-rect width="130px" height="30px" borderRadius="2rem"></app-skeleton-rect>

        <!-- Title -->
        <app-skeleton-rect width="60%" height="26px" borderRadius="6px"></app-skeleton-rect>

        <!-- Description lines -->
        <div class="skel-desc-lines">
          <app-skeleton-rect width="100%" height="14px"></app-skeleton-rect>
          <app-skeleton-rect width="90%" height="14px"></app-skeleton-rect>
          <app-skeleton-rect width="60%" height="14px"></app-skeleton-rect>
        </div>

        <!-- Feature chips -->
        <div class="skel-tag-chips">
          <app-skeleton-rect width="100px" height="26px" borderRadius="2rem"></app-skeleton-rect>
          <app-skeleton-rect width="85px" height="26px" borderRadius="2rem"></app-skeleton-rect>
          <app-skeleton-rect width="75px" height="26px" borderRadius="2rem"></app-skeleton-rect>
          <app-skeleton-rect width="80px" height="26px" borderRadius="2rem"></app-skeleton-rect>
        </div>

        <!-- Thumbnail strip -->
        <div class="skel-thumb-strip">
          <ng-container *ngFor="let t of thumbStrip">
            <app-skeleton-rect width="56px" height="40px" borderRadius="6px"
              [style.min-width]="'56px'" [style.min-height]="'40px'">
            </app-skeleton-rect>
          </ng-container>
        </div>

        <!-- CTA button -->
        <div class="skel-actions skel-actions--end">
          <app-skeleton-rect width="180px" height="44px" borderRadius="8px"></app-skeleton-rect>
        </div>
      </div>
    </div>
  </div>

  <!-- Basic template cards grid + Coming Soon -->
  <div class="row match-height">
    <div *ngFor="let card of catalogCards" class="col-12 col-md-6 col-xl-4 mb-3">
      <div class="skel-template-card">
        <!-- Card header -->
        <div class="skel-template-card__header">
          <app-skeleton-rect width="70%" height="20px"></app-skeleton-rect>
          <app-skeleton-rect width="80px" height="24px" borderRadius="1rem"></app-skeleton-rect>
          <app-skeleton-rect width="100%" height="12px"></app-skeleton-rect>
          <div class="skel-tag-chips skel-tag-chips--small">
            <app-skeleton-rect width="60px" height="22px" borderRadius="2rem"></app-skeleton-rect>
            <app-skeleton-rect width="70px" height="22px" borderRadius="2rem"></app-skeleton-rect>
          </div>
        </div>

        <!-- Image area -->
        <div class="skel-template-card__image">
          <app-skeleton-rect width="100%" height="100%" borderRadius="0"></app-skeleton-rect>
        </div>

        <!-- Footer: theme circles + button -->
        <div class="skel-template-card__footer">
          <div class="skel-theme-circles">
            <ng-container *ngFor="let theme of themeCircles">
              <app-skeleton-rect width="22px" height="22px"
                [style.min-width]="'22px'" [style.min-height]="'22px'"
                borderRadius="50%">
              </app-skeleton-rect>
            </ng-container>
          </div>
          <app-skeleton-rect width="130px" height="38px" borderRadius="8px"></app-skeleton-rect>
        </div>
      </div>
    </div>

    <!-- Coming Soon card -->
    <div class="col-12 col-md-6 col-xl-4 mb-3">
      <div class="skel-template-card skel-template-card--coming-soon">
        <div class="skel-template-card__header">
          <app-skeleton-rect width="60%" height="20px"></app-skeleton-rect>
          <app-skeleton-rect width="100px" height="24px" borderRadius="1rem"></app-skeleton-rect>
        </div>
        <div class="skel-coming-soon-preview">
          <app-skeleton-rect width="72px" height="72px"
            [style.min-width]="'72px'" [style.min-height]="'72px'"
            borderRadius="50%">
          </app-skeleton-rect>
          <div class="skel-coming-soon-lines">
            <app-skeleton-rect width="100%" height="4px" borderRadius="2px"></app-skeleton-rect>
            <app-skeleton-rect width="60%" height="4px" borderRadius="2px"></app-skeleton-rect>
            <app-skeleton-rect width="80%" height="4px" borderRadius="2px"></app-skeleton-rect>
          </div>
        </div>
        <div class="skel-template-card__footer skel-template-card__footer--center">
          <app-skeleton-rect width="80%" height="14px"></app-skeleton-rect>
        </div>
      </div>
    </div>
  </div>
</div>
